import type { AuthUserInterface } from '../model/auth.types';
import type { DepartmentInterface } from '@/shared/model/api.types';
import { DEPARTMENTS_PLAN_IDS } from '@/features/Sale/Dashboard/model/dashboard.types';

export const SALES_SYSTEM_BX_USER_IDS = [1, 184] as const;
export const COMMERCIAL_DEPARTMENT_ID = 74;

type SalesIdentity = {
  id?: AuthUserInterface['id'];
  is_admin?: AuthUserInterface['is_admin'];
  bx?: { bx_user?: { bx_id?: number } };
};

export function isSalesSystemAccount(user: SalesIdentity | null | undefined): boolean {
  const bxId = Number(user?.bx?.bx_user?.bx_id ?? 0);
  return SALES_SYSTEM_BX_USER_IDS.includes(bxId as (typeof SALES_SYSTEM_BX_USER_IDS)[number]);
}

export function isCommercialDirector(user: SalesIdentity | null | undefined): boolean {
  return Number(user?.id) === 8 || Number(user?.bx?.bx_user?.bx_id) === 8;
}

export function canSeeCommercialOverview(user: SalesIdentity | null | undefined): boolean {
  return isCommercialDirector(user) || isSalesSystemAccount(user);
}

/** КД первым, затем только отделы, по которым приложение считает планы и факт. */
export function salesAdministrationDepartments(departments: DepartmentInterface[]): DepartmentInterface[] {
  const order = [COMMERCIAL_DEPARTMENT_ID, ...DEPARTMENTS_PLAN_IDS] as readonly number[];
  const byId = new Map(departments.map((department) => [department.id, department]));
  return order.map((id) => byId.get(id)).filter((item): item is DepartmentInterface => Boolean(item));
}
